import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from '@shared/rx';

export interface IComponentCanDeactivate {
  canDeactivate: (
    component: IComponentCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ) => Observable<boolean> | Promise<boolean> | boolean;
}

export class ExitEditGuard implements CanDeactivate<IComponentCanDeactivate> {
  public canDeactivate(
    component: IComponentCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return component.canDeactivate
      ? component.canDeactivate(
          component,
          currentRoute,
          currentState,
          nextState,
        )
      : true;
  }
}
